// This file is auto-generated by running `yarn svg:process`

import * as React from 'react'

export const DocumentSvg = (
  props: React.SVGProps<SVGSVGElement>,
): React.ReactElement => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 300 300"
      height={props.height}
      width={props.width}
      fill={props.fill}
    >
      <path d="M61 24.3c-1.9 1.2-4.2 3.6-5.2 5.3-1.8 3-1.8 8.6-1.8 120.5 0 110.9.1 117.4 1.8 120.3 1 1.7 3.3 4.1 5.2 5.3l3.3 2.3h85.6c83.7 0 85.7-.1 88.9-2 1.8-1.1 4.1-3.4 5.2-5.2 1.9-3.2 2-5.3 2-91.1 0-62.2-.3-88.5-1.1-90-1.6-3.1-62.8-64.5-66.1-66.3-2.3-1.2-12-1.4-58.6-1.4H64.3L61 24.3zM166 68c0 28.7.1 30.1 2 32 1.9 1.9 3.3 2 32 2h30v160H70V38h96v30zm34 .5L217.5 86H182V68.5c0-9.6.1-17.5.3-17.5.1 0 8.1 7.9 17.7 17.5z" />
      <path d="M102 94v8h32V86h-32v8zM102 158v8h96v-16h-96v8zM102 206v8h96v-16h-96v8z" />
    </svg>
  )
}
